import React from "react";
import { Link } from "react-scroll";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="container-fluid">
      <nav
        className="navbar navbar-expand-lg col-sm-auto col-12"
        aria-label="Bottom navigation"
      >
        <ul className="navbar-nav hstack row-gap-1 column-gap-3 flex-wrap">
          <li className="nav-item nav-item-menu">
            <Link className="nav-link" delay={0} to="features" offset={-50}>
              Features
            </Link>
          </li>
          <li className="nav-item nav-item-menu">
            <Link className="nav-link" delay={0} to="benefits" offset={-50}>
              Benefits
            </Link>
          </li>
          <li className="nav-item nav-item-menu">
            <Link className="nav-link" delay={0} to="team" offset={-50}>
              Team
            </Link>
          </li>
          <li className="nav-item nav-item-menu">
            <Link className="nav-link" delay={0} to="faq" offset={-50}>
              FAQ
            </Link>
          </li>
        </ul>

        <div className="footer-copyrights col-sm-auto col-12">
          <span>© Copyright {currentYear} - Daysketcher</span>
          <span>
            <a href="DaysketcherTermsofService.html" target="_blank">
              <u>Terms of Service</u>
            </a>{" "}
            |{" "}
            <a href="DaysketcherPrivacyPolicy.html" target="_blank">
              <u> Privacy Policy</u>
            </a>
          </span>
        </div>

        <div className="hstack gap-3 col-sm-auto col-12 justify-content-center">
          <a
            className="instagram-button"
            href="https://www.instagram.com/daysketcher_app/"
            aria-label="Find more about us on Instagram"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-2x fa-instagram text-white"></i>
          </a>
          <a
            className="facebook-button"
            href="https://www.facebook.com/daysketcher"
            aria-label="Find more about us on Facebook"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-2x fa-facebook text-white"></i>
          </a>
          <a
            className="twitter-button"
            href="https://twitter.com/daysketcher_app"
            aria-label="Find more about us on Twitter"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-2x fa-x-twitter text-white"></i>
          </a>
          <a
            className="linkedin-button"
            href="https://www.linkedin.com/company/daysketcher/"
            aria-label="Find more about us on LinkedIn"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-2x fa-linkedin text-white"></i>
          </a>
        </div>
      </nav>
    </footer>
  );
};

export default Footer;
